const swiperReviews = new Swiper(".swiper-reviews", {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 16,
  
    breakpoints: {
      768: {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 40,
      },
    },
  
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
  });
  